import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function FullBandsSection() {
  const { t } = useTranslation('home');

  return (
    <section className="w-full py-16 md:py-24 px-6 md:px-10 lg:px-16 bg-white">
      <div className="flex flex-col lg:flex-row gap-8 lg:gap-16 items-center">
        <div className="w-full lg:w-1/2">
          <span className="inline-flex items-center px-4 py-1.5 text-xs font-medium text-gray-700 border border-gray-300 rounded-full mb-6 md:mb-8">
            {t('fullBands.label')}
          </span>
          <div className="relative rounded-2xl md:rounded-3xl overflow-hidden aspect-[4/3]">
            <img
              src="https://readdy.ai/api/search-image?query=full%20band%20performing%20on%20grand%20Las%20Vegas%20concert%20stage%2C%20large%20ensemble%20with%20drums%20guitars%20keyboards%20brass%20and%20vocals%2C%20dramatic%20concert%20lighting%20with%20golden%20amber%20and%20warm%20colors%2C%20professional%20photography%2C%20dark%20background%20with%20spectacular%20stage%20lights%2C%20high%20energy%20live%20performance%2C%20luxury%20venue%20atmosphere&width=800&height=600&seq=28&orientation=landscape"
              alt="Full band on Las Vegas stage"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
          </div>
        </div>

        <div className="w-full lg:w-1/2">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
            {t('fullBands.titleLine1')}
            <br />
            {t('fullBands.titleLine2')}
            <br />
            {t('fullBands.titleLine3')}
            <br />
            {t('fullBands.titleLine4')}
          </h2>
          <p className="mt-4 md:mt-6 text-sm md:text-base text-gray-500 leading-relaxed max-w-md">
            {t('fullBands.description')}
          </p>
          <p className="mt-3 text-sm md:text-base text-gray-500 leading-relaxed max-w-md">
            {t('fullBands.description2')}
          </p>
          <Link
            to="/artistas?categoria=bands"
            className="inline-flex items-center gap-2 mt-6 md:mt-8 px-6 py-3.5 bg-gray-900 text-white text-sm font-medium rounded-full hover:bg-amber-700 transition-colors whitespace-nowrap"
          >
            {t('fullBands.cta')}
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}